import React from "react";
import PropTypes from "prop-types";
import { Modal as MuiModal, Typography, Box } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import CloseIcon from "@material-ui/icons/Close";
import useStyles from "./styles";
import { hideModal } from "../../../../usecases/commons/hide-modal";

export default function Modal({
  title,
  children,
  disableClose,
  horizontalPadding,
  isOpen,
  setIsOpen,
}) {
  const { container, paper, modal, closeButton, modalTitle, disabled } =
    useStyles({ horizontalPadding });

  const handleClose = () => {
    if (!disableClose) {
      if (setIsOpen !== undefined) {
        setIsOpen(false);
      } else {
        hideModal();
      }
    }
  };

  return (
    <MuiModal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={modal}
      open={isOpen === undefined || isOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <div className={container}>
        <div className={paper}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            minHeight="24px"
            mb={3}
          >
            {title && (
              <Typography variant="h6" className={modalTitle}>
                {title}
              </Typography>
            )}
            <CloseIcon
              className={`${closeButton} ${disableClose && disabled}`}
              onClick={handleClose}
            />
          </Box>
          {children}
        </div>
      </div>
    </MuiModal>
  );
}

Modal.defaultProps = {
  title: null,
  children: null,
  disableClose: false,
  horizontalPadding: 5,
  isOpen: undefined,
  setIsOpen: undefined,
};

Modal.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  disableClose: PropTypes.bool,
  horizontalPadding: PropTypes.number,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
};
